import { Server, contentClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getBookmarksByContainerContentEntityId: ApiMethod<
  string | undefined,
  Server.BookmarkedItemOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Bookmarks_Client(undefined, contentClient);

    const response = await client.bookmarks_byContainerContentEntityId_get_V1(
      undefined,
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const addBookmark: ApiMethod<
  Server.BookmarkContentEntityInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Bookmarks_Client(undefined, contentClient);
    const response = await client.bookmarks_add_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const removeBookmark: ApiMethod<
  Server.UnBookmarkContentEntityInput,
  void
> = async (data, { dispatch }) => {
  try {
    const client = new Server.Server_Bookmarks_Client(undefined, contentClient);
    await client.bookmarks_remove_post_V1(data);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
  }
};
